type GeoRegionResponse = {
  geoCountry: string;
  geoRegion: string;
  error: string;
};

export async function getGeoRegion(
  { userId }: { userId: number | null } = { userId: null }
): Promise<GeoRegionResponse> {
  try {
    const resp = await fetch(
      `/api/compliance/region${userId ? `?userId=${userId}` : ''}`,
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (resp.ok) {
      return resp.json();
    }
    throw new Error('Unable to get geo region');
  } catch (e) {
    throw new Error(e.message);
  }
}
